import { setError, setPass, setToken, setUser, startAuth } from "./authSlice";
import { getSubscription, getUser } from "../../api/user";
import useStore from 'store';
import { login, loginWithCode } from "../../api/auth";
import { useNavigate } from "react-router-dom";







export const auth =  (data, loginRequest = login, passwordless = false)=>{

  return async (dispatch)=>{


    try {

      dispatch(startAuth())
      const token =  await loginRequest(data);
      

     
        if (token.data.app === 'supplier') {   
          dispatch(setToken( token.data.token ))
       
        const user = await getUser(token.data.token, data.phone );
        const subscription = await getSubscription(user?.id, token.data.token )

          //Con el ingreso por código el usuario ya se validó con su celular, no se le pide completar la contraseña
          if (!user.complete && !passwordless) {
            dispatch(setUser( {user, status:'not-complete', subscription:subscription.data } ))
            dispatch(setPass(data.password))
          }else{

            dispatch(setUser( {user, status:'authenticated', subscription:subscription.data } ))
            dispatch(setPass(data.password))
          }
       
       }else{
        dispatch(setError({
          message: 'Esta cuenta no esta registrada como proveedor',
          link: process.env.RESTAURANT_PORTAL_URL,
          linkLabel: 'Ir al portal de comercios',
        }))
      }
    } catch (error) {
   
        if (error.response.data === 'Error interno') {
         
          dispatch(setError('Error interno por favor intentalo más tarde'))

        }else{
          dispatch(setError(error.response.data))
        }
      
    }

  }

}


//Ingreso alterno con el código de un solo uso enviado al celular
export const authCode = (data) => auth(data, loginWithCode, true)


export const me = ()=>{

  
  return async (dispatch)=>{
  

    try {
   
        const user = await getUser(token.data.token, data.phone );
    
            dispatch(setUser( {user, status:'get-user', subscription:null } ))  
               
   
    } catch (error) {

      
       
        if (error.response.data === 'Error interno') {
          
          dispatch(setError('Error interno por favor intentalo más tarde'))

        }else{
          dispatch(setError(error.response.data))
        }
      
    }

  }


}




